import React from "react";
import { Input, InputGroup } from "reactstrap";

interface Props {
    heading: string;
    searchTerm: string;
    setSearchTerm: any;
}

const SearchInputWithClear = ({ heading, searchTerm, setSearchTerm }: Props) => {

    const handleClear = () => {
        setSearchTerm('');
    };


    return (
        <div style={{ width: '100%', position: 'relative' }}>
            <InputGroup style={{ position: 'relative' }}>
                <Input
                    type="text"
                    placeholder={heading || "Search..."}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ paddingRight: '60px' }} // Add space for the clear text
                />

                {/* Clear Text */}
                {searchTerm && (
                    <p
                        onClick={handleClear}
                        style={{
                            position: 'absolute',
                            zIndex: 5,
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontSize: '12px',
                            color: '#D3D3D3',
                            margin: '0',
                            cursor: 'pointer',
                        }}
                    >
                        CLEAR
                    </p>
                )}
            </InputGroup>
        </div>
    );
};

export default SearchInputWithClear;



// WEBPACK FOOTER //
// ./src/components/common/SearchWithClear.tsx